module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ioReportItems && _vm.ioReportItems.length > 0) ? _c('v-container', {
    staticClass: "IoReport pa-0 mb-3",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ListHeader my-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }), _vm._v(" "), _c('v-col', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("IOReportDetailsList.emission")))]), _vm._v(" "), _c('v-col', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("IOReportDetailsList.code")))]), _vm._v(" "), _c('v-col', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("IOReportDetailsList.mm")))]), _vm._v(" "), _c('v-col', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("IOReportDetailsList.programed")))]), _vm._v(" "), _c('v-col', {
    staticClass: "subheading mx-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("IOReportDetailsList.start")))])], 1), _vm._v(" "), _vm._l((_vm.parsedIoItems), function(item) {
    return _c('v-layout', {
      key: _vm.title + _vm.locationName + '_io' + item.id,
      staticClass: "ListItem",
      class: {
        Active: (_vm.selectedIOReport && _vm.selectedIOReport.id === item.id)
      },
      attrs: {
        "row": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectIOReport(item)
        }
      }
    }, [_c('v-col', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_c('IOReportIcon', {
      attrs: {
        "ioDoc": item.doc
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.emission))]), _vm._v(" "), _c('v-col', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('v-col', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.millimeters) + " " + _vm._s(_vm.$t("IOReportDetailsList.mmUnit")))]), _vm._v(" "), _c('v-col', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.start_end))]), _vm._v(" "), _c('v-col', {
      staticClass: "subheading ma-1",
      attrs: {
        "xs2": ""
      }
    }, [_vm._v(_vm._s(item.start))])], 1)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5304570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CircularGraphicsComponents/IOReportDetailsList.vue
// module id = 1745
// module chunks = 0